import Vue from 'vue'
import App from './App.vue'
import store from './store'
import './../node_modules/bootstrap/dist/css/bootstrap.min.css';
//import './../node_modules/bulma/css/bulma.css';

Vue.config.productionTip = false

new Vue({
  store,
  render: h => h(App)
}).$mount('#app')
